export const requestInitialState = {
    isLoading: false,
    isSuccessful: false,
    error: null,
    data: {},
}